import API from './API';
//import CwThemeFramework from '@customjs/generalFns.js';
import four04 from '../views/404';

/**
 * Load More Function
 */
class LoadMore {
  constructor({ enablePagination }) {
    this.button = '';
    this.loadMoreIcon = '';
    this.postType = '';
    this.category = '';
    this.nextPage = '';
    this.totalPages = '';
    this.currentMaxOfPages = '';
    this.enablePagination = enablePagination;
    this.paginationLinks = '';
    this.fullRender = false;
    this.filtering = false;
    this.topFilter = false;
  }

  init() {
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('load-more')) {
        // Load more button has been clicked
        this.button = e.target;
        this.loadMoreIcon =
          this.button.parentNode.parentNode.querySelector('.load-more-gif') ||
          document.querySelector('.load-more-gif');
        this.postType = this.button.dataset.posttype;
        this.nextPage = parseInt(this.button.dataset.nextPage);
        this.totalPages = parseInt(this.button.dataset.totalPages);
        this.category = this.button.dataset.category;
        this.filtering = !this.button.dataset.topFilter
          ? false
          : this.button.dataset.topFilter === 'true';
        this.topFilter = this.button.dataset.topFilter === 'true';

        // Check if we are receiving a valid post type
        if (API[this.postType]) {
          this.loadMoreGif('enable');
          this.getData(this.button);
          this.checkButtonPagination();
        } else {
          throw Error('Post Type not found');
        }
      }
    });
  }

  filter(categoryFilterElement) {
    categoryFilterElement.addEventListener('change', (e) => {
      this.postType = categoryFilterElement.dataset.postType;
      this.category = categoryFilterElement.value;
      this.loadMoreIcon = document.querySelector('.load-more-gif');
      this.filtering = true;

      if (API[this.postType]) {
        this.loadMoreGif('enable');
        this.getData(categoryFilterElement, true);
      }
    });
  }

  async getData(element, filtering = false) {
    const { nextPage, totalPages, gridClass, nonce, postsPerPage, pagination } =
      element.dataset;

    let outputHTML = '';

    const gridContainer = null || document.querySelector(gridClass);

    if (gridContainer) {
      let endpointURL = `/${API[this.postType].endpoint}/${nextPage}/`;
      let podcastEvent = false;
      
      const ajaxCall = await fetch(endpointURL, {
        method: 'POST',
        body: JSON.stringify({
          wpnonce: nonce,
          posts_per_page: postsPerPage,
          post_type: this.postType,
        }),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      });

      const items = await ajaxCall.json();

      if (!items.success) throw Error('Something happened with your request');
      if (items.success && items.data['max-num-pages'] > 0) {
        this.currentMaxOfPages = items.data['max-num-pages'];

        this.paginationLinks = items.data['pagination-links'];

        // Rendering Function
        this.renderHTML(items.data, gridContainer);

        if (this.enablePagination === 'enable') {
          this.updatePagination();
          this.fullRender = true;
        }

        if (this.filtering && this.enablePagination !== 'enable') {
          this.updateButtonFilter();
          this.fullRender = true;
        }

        if (podcastEvent) document.dispatchEvent(new Event('podcast_duration'));
      } else {
        const viewHTML = four04();
        gridContainer.innerHTML = viewHTML;
      }
    }
    this.loadMoreGif('disable');
  }

  /**
   * This function would receive a view to render and an option to do a full render or not
   */
  renderHTML(data, gridContainer) {
    const viewHTML = API[this.postType].view(data);
    if (this.enablePagination === 'enable' || this.filtering) {
      this.fullRender = true;
    } else {
      this.fullRender = false;
    }

    if (!this.fullRender) {
      gridContainer.insertAdjacentHTML('beforeend', viewHTML);
    } else {
      gridContainer.innerHTML = viewHTML;
    }
  }

  updatePagination() {
    document.querySelector('.blog-navigation').innerHTML = this.paginationLinks;
  }

  updateButtonFilter() {
    const loadMoreBTN = document.querySelector(
      '.load-more-btn-container .load-more'
    );
    if (loadMoreBTN) {
      this.button = loadMoreBTN;
      if (this.currentMaxOfPages <= 1) {
        this.disableButton();
      } else {
        this.enableButton();
        this.button.dataset.nextPage = 2;
        this.button.dataset.category = this.category;
        this.button.dataset.totalPages = this.currentMaxOfPages;
      }
    }
  }

  /**
   * Enable/Disable Gif
   * @param {*} action
   * @param {*} gifIcon
   */
  loadMoreGif(action) {
    'disable' === action
      ? this.loadMoreIcon.classList.add('d-none')
      : this.loadMoreIcon.classList.remove('d-none');
  }

  /**
   * Check Button Pagination
   * @param {*} loadMoreButton
   * @param {*} nextPage
   * @param {*} totalPages
   */
  checkButtonPagination() {
    if (this.topFilter) {
      this.toggleDisableClass();
    } else if (this.nextPage >= this.totalPages) {
      this.disableButton();
    } else {
      this.incrementPagination();
    }
  }

  toggleDisableClass() {
    const parentButtonsContainer = this.button.parentNode;
    const disabledButton = parentButtonsContainer.querySelector('.active');
    if (disabledButton) {
      disabledButton.classList.remove('active');
    }
    this.button.classList.add('active');
  }

  /**
   * Disable Button
   * @param {*} btn
   */
  disableButton(hide = true) {
    this.button.setAttribute('disabled', true);

    if (hide) this.button.classList.add('d-none');
  }

  enableButton() {
    this.button.removeAttribute('disabled');
    this.button.classList.remove('d-none');
  }

  /**
   * Increment Pagination
   * @param {*} btn
   * @param {*} currentPage
   */
  incrementPagination() {
    this.button.dataset.nextPage = ++this.nextPage;
  }
}

export default LoadMore;